<template>
  <basic-container id="handover2022">
    <avue-crud
      :search.sync="searchForm"
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="sentryBoxIdSearch">
        <el-select v-model="sentryBoxId" style="width: 100%" placeholder="岗亭名称" clearable>
          <el-option
            v-for="item in sentryBoxNameList"
            :key="item.id"
            :label="item.sentryBoxName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.handover_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="shiftTotalAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.shiftTotalAmount) }}
      </template>
      <template slot="shiftActualAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.shiftActualAmount) }}
      </template>
      <template slot="shiftOutflowAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.shiftOutflowAmount) }}
      </template>
      <template slot="shiftDiscountAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.shiftDiscountAmount) }}
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/handoverv2/handover';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { getSentryBoxList } from '@/api/v4ward/park/sentryv2/parksentrybox';

export default {
  data() {
    return {
      searchForm: {},
      form: {},
      query: {
        parkingLotId: '',
      },
      sentryBoxId: '',
      spaceList: [],
      tempParkingLotId: '',
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      reWrite: false,
      selectionList: [],
      sentryBoxNameList: [],
      option: {
        tip: true,
        tree: true,
        searchShow: true,
        searchMenuSpan: 12,
        height: 'auto',
        //calcHeight: 30,
        border: true,
        index: true,
        viewBtn: true,
        labelWidth: 180,
        selection: false,
        selectionClearBtn: false,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            //dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            editDisabled: true,
            search: true,
            searchSpan: 6,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '岗亭名称',
            prop: 'sentryBoxId',
            hide: true,
            span: 12,
            search: true,
            searchslot: true,
            searchSpan: 6,
            viewDisplay: false,
            // formslot: true,
            rules: [
              {
                required: true,
                message: '请选择岗亭',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '岗亭名称',
            prop: 'sentryBoxName',
            search: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '接班时间',
            prop: 'shiftStart',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 140,
            rules: [
              {
                required: true,
                message: '请输入接班时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交班时间',
            prop: 'shiftEnd',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 140,
            rules: [
              {
                required: true,
                message: '请输入交班时间',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var startshift = Date.parse(this.form.shiftStart);
                  var endshift = Date.parse(value);
                  if (startshift >= endshift) {
                    callback(new Error('交班时间必须大于接班日期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '当班总应收金额',
            prop: 'shiftTotalAmount',
            maxlength: 10,
            width: 110,
            showWordLimit: true,
            slot: true,
            align: 'right',
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [
              {
                required: true,
                message: '请输入当班总应收金额',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
            minRows: 0.01,
          },
          {
            label: '当班总实收金额',
            prop: 'shiftActualAmount',
            maxlength: 10,
            width: 110,
            slot: true,
            align: 'right',
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [
              {
                required: true,
                message: '请输入当班总实收金额',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
            minRows: 0.01,
          },
          {
            label: '优惠金额',
            prop: 'shiftDiscountAmount',
            maxlength: 10,
            slot: true,
            align: 'right',
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [
              {
                required: true,
                message: '请输入优惠金额',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
            minRows: 0.01,
          },
          {
            label: '未收金额',
            prop: 'shiftOutflowAmount',
            maxlength: 10,
            slot: true,
            align: 'right',
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [
              {
                required: true,
                message: '请输入未收金额',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
            minRows: 0.01,
          },
          {
            label: '当班人ID',
            prop: 'shiftUserId',
            rules: [
              {
                required: true,
                message: '请输入当班人ID',
                trigger: 'change',
              },
            ],
            hide: true,
            showColumn: false,
          },
          {
            label: '当班人账号',
            prop: 'shiftAccount',

            rules: [
              {
                required: true,
                message: '请输入当班人账号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '当班人姓名',
            prop: 'shiftUsername',
            rules: [
              {
                required: true,
                message: '请输入当班人姓名',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
            hide: true,
            showColumn: false,
            rules: [
              {
                required: false,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.handover_add, false),
        viewBtn: this.vaildData(this.permission.handover_view, true),
        delBtn: this.vaildData(this.permission.handover_delete, true),
        editBtn: this.vaildData(this.permission.handover_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.parkingLotId'() {
      // this.loadPassageSelections(this.form.parkingLotId);
      this.form.passageId = '';
    },
    'searchForm.parkingLotId'() {
      console.log('Avcdhdsfs');
      this.getSentryBoxList(this.searchForm.parkingLotId);
    },
  },
  created() {
    this.option.height = this.bodyHeight - 380;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        getSentryBoxList({
          spaceId: this.spaceList[0].id,
        }).then((data) => {
          this.sentryBoxNameList = data.data;
        });
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 380) {
              this.option.height = this.bodyHeight - 300;
            } else {
              this.option.height = this.bodyHeight - 380;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    getSentryBoxList(spaceId) {
      if (!spaceId) {
        return;
      }
      getSentryBoxList({
        spaceId: spaceId,
      }).then((data) => {
        this.sentryBoxNameList = data.data;
      });
    },

    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        // getDetail({ id: this.form.id }).then(({ data }) => {
        //   this.form = data;
        // });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.sentryBoxId) {
        this.query.sentryBoxId = this.sentryBoxId;
      }
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
#handover2022 .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
  /* padding-right: -50px; */
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
